// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

// Components
import { DateTimePicker } from 'material-ui-pickers';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';
import { MenuItem } from '@material-ui/core';

interface State {
  pdf: any;
  fileExists: boolean;
  camp: any;
  camps: any;
  dateBegin: any;
  dateEnd: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  isFinished: boolean;
  isUpdating: boolean;
  key: any;
  text: any;
  textUpdated: any;
  title: any;
  toLocation: any;
  toDate: Date | null;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class CampEditionProfile extends React.Component<Props, State> {

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      pdf: null,
      fileExists: false,
      camp: 0,
      camps: [],
      dateBegin: null,
      dateEnd: null,
      employee: "",
      errors: [],
      files: "",
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      key: "",
      product: "",
      products: [],
      text: "",
      textUpdated: "",
      title: "",
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  formatDate = (date: any) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1).toString();
    let day = '' + d.getDate().toString();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  async componentWillMount() {
    await NetworkManager.request(`camp`, MethodRequest_e.GET).then((result) => {
      this.setState({
        camps: result
      });
    });

    if (this.state.isUpdating) {
      await NetworkManager.request(`campedition/${this.props.match.params.id}`, MethodRequest_e.GET).then((article) => {
        this.setState({
          dateBegin: article.datebegin,
          dateEnd: article.dateend,
          camp: article.camp_id
        });
      });
      await NetworkManager.request(`pdfexists/campedition/${this.props.match.params.id}`, MethodRequest_e.GET).then((res) => {
        this.setState({
          fileExists: res
        });
      });
    }
  }

  padLeft(originalString: string, length: number, character: string): string {
    const numberChars: number = length - originalString.length;
    let completedString = originalString;

    //Iterate to add the number of specific character
    for (let i = 0; i < numberChars; i++) {
      completedString = character + completedString;
    }

    return completedString;
  }

  handlePdfChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        files: file.name,
        pdf: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  handleChange = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  updateContent = (newContent: any) => {
    this.setState({
      text: newContent
    });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.camp == 0) {
        errors['camp'] = "Ajouter un type de camp";
      }
      if (this.state.dateBegin == null) {
        errors['dateBegin'] = "Ajouter une date de début";
      }
      if (this.state.dateEnd == null) {
        errors['dateEnd'] = "Ajouter une date de fin";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} de l'édition en cours...`);

        const dB = this.formatDate(this.state.dateBegin);
        const dE = this.formatDate(this.state.dateEnd);
        try {

          await NetworkManager.request(
            `campedition${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
            datebegin: dB,
            dateend: dE,
            camp_id: this.state.camp
          }).then((response) => {
            if (this.state.pdf != null) {
              NetworkManager.request(
                `pdf/campedition/${response.id}`,
                MethodRequest_e.POST, {
                pdf: this.state.pdf
              });
            }
            MainStore.showNotification(response.text);
            MainStore.goBack(this.props.history.location.pathname);
            this.props.history.goBack();
          });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {

    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'une édition</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <TextField
              label="Camp"
              name="camp"
              value={this.state.camp}
              error={Boolean(this.state.errors['camp'])}
              helperText={this.state.errors['camp']}
              fullWidth={true}
              select={true}
              onChange={this.handleChange()}
            >
              <MenuItem value={0} disabled={true}>Sélectionner un type de camp</MenuItem>
              {this.state.camps.map((c: any, key: number) => {
                return <MenuItem value={c.id} key={key}>{c.title}</MenuItem>;
              })}
            </TextField>
          </Grid>
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <DateTimePicker
              ampm={false}
              label="Date de début"
              name="dateBegin"
              format="DD.MM.YYYY HH:mm"
              value={this.state.dateBegin}
              error={Boolean(this.state.errors['dateBegin'])}
              helperText={this.state.errors['dateBegin']}
              fullWidth={true}
              onChange={(date) => { this.setState({ dateBegin: date }); }} />
          </Grid>
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <DateTimePicker
              ampm={false}
              label="Date de fin"
              name="dateEnd"
              format="DD.MM.YYYY HH:mm"
              value={this.state.dateEnd}
              error={Boolean(this.state.errors['dateEnd'])}
              helperText={this.state.errors['dateEnd']}
              fullWidth={true}
              onChange={(date) => { this.setState({ dateEnd: date }); }} />
          </Grid>
          {!this.state.fileExists &&
            <Grid item={true} xs={12} className="form-field">
              <Typography variant="body2">Fichier d'inscription</Typography>
              <input
                accept="application/pdf"
                id="raised-button-file"
                type="file"
                onChange={this.handlePdfChange}
                hidden={true}
              />
              <br />
              <p>{this.state.files}</p>

              <label htmlFor="raised-button-file">
                <Button color="primary" size="small" variant="contained" component="span">Sélectionner fichier pdf</Button>
              </label>
            </Grid>
          }
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/CampEditionProfile.tsx